var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play-banner"},[_vm._m(0),_c('router-link',{staticClass:"button button-green",attrs:{"to":"/"}},[_vm._v(" Играть ")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ol',[_c('li',[_vm._v(" Играйте ")]),_c('li',[_vm._v(" Находите секретные элементы ")]),_c('li',[_vm._v(" Выигрывайте антистресс-подарки от Леруа Мерлен ")])])
}]

export { render, staticRenderFns }